import { motion } from "framer-motion";
import { ShieldCheck, Lock } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const IMG_CONTRACT =
  "https://images.pexels.com/photos/7876037/pexels-photo-7876037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="relative py-28 sm:py-36 overflow-hidden">
    <div className="absolute inset-0 -z-10">
      <img src={IMG_CONTRACT} alt="" className="w-full h-full object-cover opacity-20" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1320] via-[#0B1320]/85 to-[#0B1320]" />
    </div>

    <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-amber-400/90 mb-6">
          O próximo passo é seu
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-100 leading-tight">
          Cada dia sem estratégia é um dia a mais de patrimônio <span className="gold-text italic">em risco.</span>
        </h2>
        <p className="text-sm sm:text-base text-slate-400 leading-relaxed mt-6 max-w-xl mx-auto">
          Uma conversa confidencial de minutos pode definir o destino de décadas de trabalho.
          Fale agora com a TSS — ADVOGADOS.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <motion.a
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          href={waLink(WA_MESSAGES.final)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-whatsapp"
          className="inline-flex items-center gap-3 gold-surface text-[#0B1320] font-bold text-base sm:text-lg px-10 py-5 rounded-full mt-10 shadow-[0_0_50px_rgba(212,175,55,0.4)] hover:shadow-[0_0_80px_rgba(212,175,55,0.6)] transition-shadow duration-300"
        >
          <ShieldCheck className="w-6 h-6" />
          Proteger Meu Patrimônio Agora
        </motion.a>
        <p className="flex items-center justify-center gap-2 text-xs text-slate-500 mt-6">
          <Lock className="w-3.5 h-3.5 text-amber-500/70" />
          Atendimento confidencial · Resposta em horário comercial
        </p>
      </Reveal>
    </div>
  </section>
);
